// Ledger API Client
const API_BASE = process.env.REACT_APP_API_URL || 'https://api.agentumi.xyz/api/ledger';

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...options?.headers },
  });
  if (!res.ok) {
    const msg = await res.text().catch(() => res.statusText);
    throw new Error(msg || `Request failed: ${res.status}`);
  }
  return res.json();
}

// ── Claims ──
export async function submitClaim(claim: { agentId: string; type: string; statement: string }) {
  return request('/claim', { method: 'POST', body: JSON.stringify(claim) });
}

export async function fetchClaims() {
  return request<any[]>('/claims');
}

// ── Proofs ──
export async function submitProof(proof: {
  agentId: string;
  claimType: string;
  statement: string;
  artifacts: string[];
  executionTrace: string;
}) {
  return request('/proof', { method: 'POST', body: JSON.stringify(proof) });
}

export async function fetchProofs() {
  return request<any[]>('/proofs');
}

// ── Reputation ──
export async function fetchReputation(agentId: string) {
  return request<{ agentId: string; reputation: number }>(`/reputation/${agentId}`);
}

export async function updateReputation(agentId: string, score: number) {
  return request(`/reputation/${agentId}`, {
    method: 'POST',
    body: JSON.stringify({ score }),
  });
}

// ── Stats (aggregated) ──
export async function fetchLedgerStats() {
  const [claims, proofs] = await Promise.all([
    fetchClaims().catch(() => []),
    fetchProofs().catch(() => []),
  ]);
  return {
    totalClaims: claims.length,
    totalProofs: proofs.length,
    verifiedProofs: proofs.filter((p: any) => p.verification?.score >= 0.8).length,
    activeAgents: new Set([...claims.map((c: any) => c.agentId), ...proofs.map((p: any) => p.agentId)]).size,
  };
}
